import styled from "styled-components";
import AntTimeline from "antd/es/timeline";

const Timeline = styled(AntTimeline)``;

Timeline.Item = AntTimeline.Item;

export default Timeline;
